<form [formGroup]="specPUFormGroup">
    <div formGroupName="specificatiePU">
        <div formGroupName="opbouw">
                <div class="row">
                    <div class="col col-1">
                        <p>Alimentatie</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                formControlName="saldoAlimentatie"
                                id="saldoAlimentatie"
                                class="custom-input-150"
                                align="right"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
                <div class="row">
                    <div class="col col-1">
                        <p>Periodieke uitkeringen</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                formControlName="saldoPeriodiekeUitkeringen"
                                id="saldoPeriodiekeUitkeringen"
                                class="custom-input-150"
                                align="right"
                                [decimals]="0"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
</form>

